import { useWizard } from "@/app/auth/signup/signup.components/wizard/wizard.hooks";
import { Button } from "@/components/ui/button";

export default function VerifyEmailPending() {
    const { email, sendingConfirmationEmail, resendConfirmationEmail } = useWizard();

    return (
        <div className="space-y-4 text-center">
            <h1 className="text-2xl font-bold">Verify your e-mail</h1>
            <p className="text-sm text-muted-foreground">
                We’ve sent a confirmation link to <strong>{email}</strong>. <br />
                Click it to activate your account.
            </p>
            <Button disabled={sendingConfirmationEmail} onClick={resendConfirmationEmail}>
                {sendingConfirmationEmail ? "Sending…" : "Resend e-mail"}
            </Button>
        </div>
    );
}